/**
 * cookie
 */

import cookie from 'js-cookie'
import url from '@common/url'

/**
 * 获取cookie
 * @param {string} key
 */
const get = (key) => {
  return cookie.get(key)
}

/**
 * 设置cookie
 * @param {string} key
 * @param {*} val
 * @param {number} timeout 过期时间
 */
const set = (key, val, timeout = 0) => {
  const options = {
    domain: url('domain')
  }
  if (timeout && typeof timeout === 'number') {
    options.expires = timeout / 864e+2
  }
  cookie.set(key, val, options)
}

/**
 * 移除cookie
 * @param {string} key
 */
const clear = (key) => {
  cookie.remove(key)
}

export default {
  get,
  set,
  clear
}


// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/node_modules/@common/collect/src/lib/cookie-kit.js